import React, { useCallback, useEffect } from 'react';
import { When } from 'react-if';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import './styles.css';
import { useToggle } from 'react-use';
import AccountSettingsModal from '../../elements/customModals/AccountSettingsModal/AccountSettingsModal';
import MyTeamsModal from '../../elements/customModals/MyTeamsModal/MyTeamsModal';
import InviteFriendsModal from '../../elements/modal/InviteFriendsModal';
import { useAuth } from '../../../hooks/useAuth';
import * as ROUTES from '../../../constants/routes';
import NavBar from '../NavBar';
import { withPostProvider } from '../../../providers/PostProvider';
import { Outlet } from 'react-router-dom';
import FilterQuestionBar from '../../post/elements/FilterQuestionBar';
import { useDispatch, useSelector } from 'react-redux';
import { useActions } from '../../../hooks/useActions';
import AppLoader from '../../appLoader/AppLoader';

const MainLayout = ({ isPreview }) => {
    const {
        currentUser: { uid, email, inviteCode },
        authLoading,
    } = useAuth();

    const dispatch = useDispatch();
    const location = useLocation();
    let isDisabled = location.pathname.includes(ROUTES.CREATE_POST);

    const { fetchNewInvitationsPostCount, setActiveCategory, getAuthUserInfo } = useActions();

    const { invitationsPostCount, pendingPostCount, publishedPostCount, loading } = useSelector(
        state => state.notifications
    );
    const { activeCategory } = useSelector(state => state.categories);

    const [isCreateTeamPopupOpens, toggleCreateTeamPopup] = useToggle(false);
    const [isMyTeamPopupOpens, toggleMyTeamPopup] = useToggle(false);
    const [isInviteFriendsPopupOpens, toggleInviteFriendsPopup] = useToggle(false);

    useEffect(() => {
        if (email) {
            fetchNewInvitationsPostCount({ email, uid });
        }
    }, [email, uid, activeCategory]);

    useEffect(() => {
        if (uid) getAuthUserInfo(uid);
    }, [uid]);

    useEffect(() => {
        if (window.location.pathname.includes(ROUTES.PROFILE)) {
            toggleCreateTeamPopup();
        }
    }, [toggleCreateTeamPopup]);

    const handleDashboardButtonClick = useCallback(() => {
        window.location.reload();
    }, []);

    const handleCategoryClick = useCallback(
        category => {
            const newCategory = activeCategory === category.uid ? null : category.uid;
            dispatch(setActiveCategory(newCategory));
        },
        [activeCategory]
    );

    return (
        <>
            {!loading && !authLoading ? (
                <div className="main-layout__container">
                    <When condition={isPreview}>
                        <div className="main-layout__preview" />
                    </When>
                    <NavBar
                        toggleCreateTeamPopup={toggleCreateTeamPopup}
                        toggleInviteFriendsPopup={toggleInviteFriendsPopup}
                        toggleMyTeamPopup={toggleMyTeamPopup}
                        invitationsCount={invitationsPostCount}
                        pendingCount={pendingPostCount}
                        publishedCount={publishedPostCount}
                    />
                    <FilterQuestionBar
                        isDisabled={isDisabled}
                        categoryToggle={handleCategoryClick}
                    />
                    <Outlet context={[activeCategory]} />
                    <When condition={isCreateTeamPopupOpens}>
                        {() => (
                            <AccountSettingsModal
                                modal={isCreateTeamPopupOpens}
                                toggle={toggleCreateTeamPopup}
                            />
                        )}
                    </When>
                    <When condition={isMyTeamPopupOpens}>
                        {() => (
                            <MyTeamsModal modal={isMyTeamPopupOpens} toggle={toggleMyTeamPopup} />
                        )}
                    </When>
                    <When condition={isInviteFriendsPopupOpens}>
                        {() => (
                            <InviteFriendsModal
                                inviteCode={inviteCode}
                                modal={isInviteFriendsPopupOpens}
                                toggle={toggleInviteFriendsPopup}
                            />
                        )}
                    </When>
                </div>
            ) : (
                <div className="posts__title-container-outer">
                    <div className="height-full align-items-center d-flex justify-content-center posts__title">
                        <AppLoader />
                    </div>
                </div>
            )}
        </>
    );
};

MainLayout.propTypes = {
    // children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    isPreview: PropTypes.bool,
};

MainLayout.defaultProps = {
    isPreview: false,
};

const enhance = compose(withPostProvider);

export default React.memo(enhance(MainLayout));
